import React, { useState, useEffect } from "react";
import "./Profile.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Wrapper from "styles/Wrapper";
import {
  faCamera,
  faGear,
  faSpinner,
  faThumbsUp
} from "@fortawesome/free-solid-svg-icons";
import PageLeft from "components/community/pageLeft/PageLeft";
import PageRight from "components/community/pageRight/PageRight";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { isCreateProfilePopState } from "recoil/contentsAtom";
import { useMediaQuery } from "react-responsive";
import { useQuery } from "react-query";
import { IGetProfileInfo, getProfileInfoApi } from "api/userInfoApi";
import {
  headersState,
  isLoginStateSelector,
  isProfileCreatedState,
  isProfileOwnerState,
  userProfileKeyState
} from "recoil/userInfoAtom";
import ContentLoader from "react-content-loader";
import { useNavigate, useParams } from "react-router-dom";
import CreateProfilePopUp from "components/community/PopUp/CreateProfilePopUp";
import LikeablePosts from "pages/LikeablePosts/LikeablePosts";
import axios from "axios";
import { BASE_PATH } from "api/commonApi";
import { loginKey } from "utils/CommonTranslationKey";
import { t } from "i18next";

function Profile() {
  const { title, profilekey } = useParams();
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const headers = useRecoilValue(headersState);
  const userProfileKey = useRecoilValue(userProfileKeyState);
  const [isScroll, setIsScroll] = useState(false);
  const [isCreateProfilePop, setIsCreateProfilePop] = useRecoilState(
    isCreateProfilePopState
  );
  const [likeState, setLikeState] = useState({ btn: false, count: 0 });
  const [isLikeLoading, setIsLikeLoading] = useState(false);
  const setisProfileOwner = useSetRecoilState(isProfileOwnerState);
  const isProfileCreated = useRecoilValue(isProfileCreatedState);
  const navigate = useNavigate();

  useEffect(() => {
    if (profilekey === undefined) {
      alert("존재하지 않은 프로필입니다");
      navigate(-1);
    }
  }, [title, profilekey]);

  const { isLoading, data } = useQuery<IGetProfileInfo>(
    ["profile", isCreateProfilePop, profilekey, isProfileCreated],
    () => getProfileInfoApi(profilekey || "", headers),
    {
      refetchOnWindowFocus: false,
      notifyOnChangeProps: "tracked"
    }
  );

  useEffect(() => {
    const titleType = title === "post" || title === "like";

    if (!isLoading) {
      if (data?.result === 1) {
        setisProfileOwner(data.data.owner);
        setLikeState({
          btn: data.data.user_profile_like_status,
          count: data.data.user_profile_info.like_count
        });

        if (titleType === undefined || !titleType) {
          navigate(`/profile/${profilekey}/post`);
        }

        if (!data.data.owner) {
          setIsCreateProfilePop(false);
          return;
        }
      }

      if (data?.result === 2 && !isProfileCreated) {
        setIsCreateProfilePop(true);
        return;
      }

      if (data?.result === -98) {
        setIsCreateProfilePop(false);
        alert("존재하지 않은 프로필입니다.");
        navigate(-1);
        return;
      }
    }
  }, [data]);

  const onClickThumbs = async () => {
    if (!isLoginState.isLogIn) {
      alert(t(loginKey));

      return;
    }

    if (!isLikeLoading) {
      try {
        setIsLikeLoading(true);
        await axios
          .put(
            `${BASE_PATH}/api/vfunlounge/profile/like?user_profile_key=${profilekey}`,
            {},
            { headers: { ...headers } }
          )
          .then((res) => {
            let data: {
              data: {
                user_profile_like_status: boolean;
                profile_like_count: number;
              };
              result: number;
            } = res.data;

            if (data.result === 1) {
              setLikeState({
                btn: data.data.user_profile_like_status,
                count: data.data.profile_like_count
              });
            } else if (data.result === -88) {
              alert(
                "존재하지 않은 프로필 유저입니다. 프로필 생성 후 이용해주세요"
              );
              navigate(`/profile/${userProfileKey}`);
            }
          });
      } catch (error) {
        console.log(error, "like profile");
      } finally {
        setIsLikeLoading(false);
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      try {
        if (window.scrollY < 200) {
          setIsScroll(false);
        } else {
          setIsScroll(true);
        }
      } catch (error) {
        // console.log(error);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const width768 = useMediaQuery({
    query: "screen and (max-width: 768px)"
  });

  if (isLoading || data?.result !== 1) {
    return (
      <Wrapper isFooter={false} title="Profile page">
        <div className="row-w" id="profile">
          <ContentLoader
            speed={2} // 속도
            viewBox="0 0 500 130"
            backgroundColor="#27292d" // 배경색
            foregroundColor="#4b4b4b" // 요소 색
          >
            <rect x="0" y="14" rx="10" ry="10" width="100%" height="110px" />
          </ContentLoader>
          <ContentLoader
            speed={2} // 속도
            viewBox="0 0 500 500"
            backgroundColor="#27292d" // 배경색
            foregroundColor="#4b4b4b" // 요소 색
          >
            <rect x="0" y="20" rx="10" ry="10" width="100%" height="400px" />
          </ContentLoader>
        </div>

        {isCreateProfilePop && <CreateProfilePopUp type={2} />}
      </Wrapper>
    );
  }

  return data?.result === 1 ? (
    <Wrapper isFooter={false} title="Profile page">
      <div className="row-w" id="profile">
        {isScroll && !width768 ? (
          // width768 이상일 때 스크롤 시 나타나는 헤더
          <div className="scroll top">
            <div className="row-w">
              <div className="user-img">
                <img
                  src={
                    data.data.user_profile_info.profile_image_url !== null
                      ? data.data.user_profile_info.profile_image_url
                      : "https://file.valofe.com/Valofe_file/web/vfun/images/common/img-user-default-min.png"
                  }
                />
                <span className="nickname">
                  {data.data.user_profile_nickname}
                </span>
              </div>

              <div className="btns">
                <button
                  className={`thumbs ${likeState.btn ? "on" : ""}`}
                  onClick={onClickThumbs}
                >
                  {!isLikeLoading ? (
                    <>
                      <FontAwesomeIcon icon={faThumbsUp} />
                      <span>{likeState.count}</span>
                    </>
                  ) : (
                    <FontAwesomeIcon icon={faSpinner} pulse />
                  )}
                </button>
                {data.data.owner && (
                  <button
                    className="setting"
                    onClick={() => setIsCreateProfilePop(true)}
                  >
                    <FontAwesomeIcon icon={faGear} />
                  </button>
                )}
              </div>
            </div>
          </div>
        ) : (
          // 그 이외 모든 헤더
          <div className="full top">
            <div className="banner-img">
              {data.data.user_profile_info.profile_background_image_url !==
              null ? (
                <img
                  src={data.data.user_profile_info.profile_background_image_url}
                />
              ) : null}
            </div>

            <div className="user-img">
              <img
                src={
                  data.data.user_profile_info.profile_image_url !== null
                    ? data.data.user_profile_info.profile_image_url
                    : "https://file.valofe.com/Valofe_file/web/vfun/images/common/img-user-default-min.png"
                }
              />
              {data.data.owner && (
                <button
                  className="btn-camera"
                  onClick={() => setIsCreateProfilePop(true)}
                >
                  <FontAwesomeIcon icon={faCamera} />
                </button>
              )}
            </div>
            <div className="user-info">
              <div className="desc">
                <div className="nickname">
                  {" "}
                  {data.data.user_profile_nickname}
                </div>
                <div className="txt ellipsis-multi">
                  {data.data.user_profile_info.profile_desc}
                </div>
              </div>
              <div className="btns">
                <button
                  className={`thumbs ${likeState.btn ? "on" : ""}`}
                  onClick={onClickThumbs}
                >
                  {!isLikeLoading ? (
                    <>
                      <FontAwesomeIcon icon={faThumbsUp} />
                      <span>{likeState.count}</span>
                    </>
                  ) : (
                    <FontAwesomeIcon icon={faSpinner} pulse />
                  )}
                </button>
                {data.data.owner && (
                  <button
                    className="setting"
                    onClick={() => setIsCreateProfilePop(true)}
                  >
                    <FontAwesomeIcon icon={faGear} />
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        <section className="page">
          <div className={`page-body ${width768 ? "" : isScroll}`}>
            <PageLeft />
            {title === "post" ? (
              <PageRight />
            ) : title === "like" ? (
              <LikeablePosts />
            ) : null}
          </div>
        </section>
      </div>

      {isCreateProfilePop && (
        <CreateProfilePopUp
          type={data.result}
          data={{
            profile: data.data.user_profile_info.profile_image_url || "",
            profile_background:
              data.data.user_profile_info.profile_background_image_url || "",
            desc: data.data.user_profile_info.profile_desc || "",
            nickname: data.data.user_profile_nickname || ""
          }}
        />
      )}
    </Wrapper>
  ) : null;
}

export default Profile;
